import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from '@redux-devtools/extension';
import {thunk} from "redux-thunk";
import rootReducer from "reducers";
import websocketMiddleware from '@/redux/mid';
import messageMiddleware from '@/redux/messageMiddleware';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { createBrowserHistory } from "history";

const browserHistory = new createBrowserHistory();

const rm = routerMiddleware(browserHistory);
const middleware = [thunk, websocketMiddleware, rm, messageMiddleware];
const store = createStore(
  //rootReducer,
  (rootReducer),
  composeWithDevTools(applyMiddleware(...middleware))
);

export const history = syncHistoryWithStore(browserHistory, store);

export default store;


